'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


function cbSlideshow() {
    return {
        restrict: 'E',
        scope: {
            // Sets the component to auto play slides. Expect: true, false
            autoPlay: '@',
            // Set the duration of each slide. Expect: number *1000 = 1s
            slideDuration: '@',
            // Set the height of the slideshow
            height: '@'
        },
        bindToController: true,
        controllerAs: 'vm',
        transclude: true,
        controller: 'cbSlideshowController',
        template: "<div class=\"cb-slideshow\">\r\n\r\n    <div class=\"cb-slideshow__track\" ng-transclude data-ng-style=\"vm.activeSlideTrack\" ng-click=\"vm.stopAutoPlay()\">\r\n        <!-- Content here via transclusion -->\r\n    </div>\r\n\r\n    <ul class=\"cb-slideshow__bulletin-list\">\r\n        <li ng-repeat=\"slide in vm.slides\">\r\n            <a href=\"\" ng-click=\"vm.stopAutoPlay(); vm.setActive(slide)\" class=\"cb-slideshow__bulletin\" data-ng-class=\"{'cb-slideshow__bulletin--active': slide.isActive}\">\r\n            </a>\r\n        </li>\r\n    </ul>\r\n\r\n</div>\r\n"
    };
}

exports.default = cbSlideshow;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/slideshow/cb-slideshow.directive.js
// module id = 912
// module chunks = 0